import { Component, OnInit } from '@angular/core';
import { AddLigneFinancementComponent } from './add-ligne-financement/add-ligne-financement.component';
import { EditLigneFinancementComponent } from './edit-ligne-financement/edit-ligne-financement.component';
import { LigneFinancement } from '../../core/model/ligneFinancement/ligneFinancement';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LigneFinancementService } from '../../core/service/ligne-financement/ligne-financement.service';

@Component({
  selector: "app-ligne-financement",
  templateUrl: "./ligne-financement.component.html",
  styleUrls: ["./ligne-financement.component.scss"]
})
export class LigneFinancementComponent implements OnInit {
  ligneFinancement: LigneFinancement[];

  constructor(
    private modalService: NgbModal,
    private _ligneFinancementService: LigneFinancementService
  ) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._ligneFinancementService.getAllLigneFinancement().subscribe(
      data => {
        this.ligneFinancement = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  edit(ligneFinancement: LigneFinancement): void {
    const modalRef = this.modalService.open(EditLigneFinancementComponent, {
      centered: true
    });
    modalRef.componentInstance.ligneFinancement = ligneFinancement;

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddLigneFinancementComponent, {
      centered: true
    });

    modalRef.result.then(
      data => {
        // on close
        this.getAll();
      },
      reason => {
        // on dismiss
      }
    );
  }
}
